import useMarkOnMount from 'crm-fe-perf/timing/hooks/useMarkOnMount';
import { MountProfileContainer } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
// TODO: fix these https://git.hubteam.com/HubSpot/CRM-Issues/issues/1874
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/email/DoubleOptInStor... Remove this comment to see the full error message
import DoubleOptInStore from 'crm_data/email/DoubleOptInStore';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/queues/QueuesStore'. ... Remove this comment to see the full error message
import QueuesStore from 'crm_data/queues/QueuesStore';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/teams/TeamsStore'. Di... Remove this comment to see the full error message
import TeamsStore from 'crm_data/teams/TeamsStore';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-objects-ui-compo... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import PropTypes from 'prop-types';
import { memo, useEffect, useMemo } from 'react';
import VidyardStore from '../extensions/vidyard/VidyardStore';
import { useSetStateForSubject } from './hooks/useSetStateForSubject';
import Profile from './Profile';
import { useApolloClient } from '@apollo/client';
import createSequenceEnrollmentTimelineStore from '../../stores/createSequenceEnrollmentTimelineStore';
import { useInitialTimelineData } from '../../hooks/useTimelineData';
import { jsx as _jsx } from "react/jsx-runtime";
const preloadStores = () => {
  QueuesStore.get();
  DoubleOptInStore.get();
  TeamsStore.get();
  VidyardStore.get();
};
function ProfileContainer({
  objectType,
  subjectId,
  query
}) {
  useMarkOnMount(MountProfileContainer);
  useEffect(() => {
    preloadStores();
  }, []);
  const client = useApolloClient();
  useEffect(() => {
    createSequenceEnrollmentTimelineStore({
      client
    });
  }, [client]);
  useSetStateForSubject(objectType, subjectId);
  useInitialTimelineData(objectType, subjectId);
  const key = objectType + subjectId + (query && query._t || '');

  // by memoizing this, we can prevent any accidental re-renders of the profile
  // that might come from higher up in the tree. Because this component contains
  // the entire application, it can have large performance implications
  const renderedRecord = useMemo(() => /*#__PURE__*/_jsx(Profile, {
    objectType: objectType,
    subjectId: subjectId,
    query: query
  }, key), [objectType, subjectId, query, key]);
  return renderedRecord;
}
ProfileContainer.displayName = 'ProfileContainer';
ProfileContainer.propTypes = {
  objectType: AnyCrmObjectTypePropType.isRequired,
  query: PropTypes.object,
  subjectId: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(ProfileContainer);